import axios from "axios";
import { apiUrl } from "../config"

export const getOrderTracking = ({order, token }) => {
    const options = {
        headers:{
        'access-token': token,
        }
      };
      
    const url = `${apiUrl}${order}`;
    return axios.get(url, options).then(res => res)
}